import AxiosInstance from '../../helpers/axios-instance/axios-instance';
import { appConfig } from '../../helpers/app-config/app-config';
import type { PrCommentsResponse, UnifiedProcessGraphResponse } from './unified-process-graph-client.type';

const axiosInstance = AxiosInstance();
const baseURL = appConfig.VITE_APP_API_URL + '/api/unified-process-graph/';

/**
 * Fetches the unified process graph data for a task
 *
 * @param {string} taskId - The UUID of the task
 * @return {Promise<UnifiedProcessGraphResponse>} - A Promise that resolves to the unified process graph response
 */
const getUnifiedProcessGraph = (taskId: string): Promise<UnifiedProcessGraphResponse> => {
  return axiosInstance
    .get(baseURL, { params: { task_id: taskId } })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error?.response?.data || 'Error while fetching unified process graph'));
};

/**
 * Fetches a task's pull request with its full review comments. The graph only
 * embeds trimmed previews; this returns complete bodies and review metadata.
 *
 * @param {string} taskId - The UUID of the task the pull request is linked to
 * @param {string} changeRequestId - The pull request's graph id (`cr_<uuid>`) or bare UUID
 * @return {Promise<PrCommentsResponse>} - A Promise that resolves to the pull request and its comments
 */
const getPrComments = (taskId: string, changeRequestId: string): Promise<PrCommentsResponse> => {
  return axiosInstance
    .get(`${baseURL}pr-comments/`, { params: { task_id: taskId, change_request_id: changeRequestId } })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error?.response?.data || 'Error while fetching pull request comments'));
};

export { getPrComments, getUnifiedProcessGraph };
